import React from 'react';
import { Link } from 'react-router-dom';

import { Page } from '@occc-app/design-system';
import { Button, AddIcon } from '@occc/ui-design-system';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { WalletsTableContainer } from './WalletsTableContainer';

import { messages } from '../messages';
import { routeCreator } from '../utils';

export const WalletListPage = () => {
  const isUserPermittedToCreateWallet = useIsUserPermittedTo(Feature.WALLET_CREATE);
  const actions = isUserPermittedToCreateWallet && (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      to={routeCreator.create()}
      startIcon={<AddIcon />}
      role='button'
    >
      new wallet
    </Button>
  );

  return (
    <Page
      browserTabTitle={messages.title}
      actions={actions}
      pageHeaderProps={{ title: messages.title }}
    >
      <WalletsTableContainer />
    </Page>
  );
};
